import moment from 'moment-timezone';
export const getIsTimePeriodSelected = (range) => {
  const isTodaySelected =
    moment(range.start).isSame(moment(), 'day') &&
    moment(range.end).isSame(moment(), 'day');
  const isYesterdaySelected =
    moment(range.start).isSame(moment().subtract(1, 'day'), 'day') &&
    moment(range.end).isSame(moment().subtract(1, 'day'), 'day');
  const isLastWeekSelected =
    moment(range.start).isSame(
      moment().subtract(1, 'week').startOf('week'),
      'day'
    ) &&
    moment(range.end).isSame(moment().subtract(1, 'week').endOf('week'), 'day');
  const isLastMonthSelected =
    moment(range.start).isSame(
      moment().subtract(1, 'month').startOf('month'),
      'day'
    ) &&
    moment(range.end).isSame(
      moment().subtract(1, 'month').endOf('month'),
      'day'
    );
  const isCustomDateRangeSelected =
    !isTodaySelected &&
    !isYesterdaySelected &&
    !isLastWeekSelected &&
    !isLastMonthSelected;
  return {
    isTodaySelected,
    isYesterdaySelected,
    isLastWeekSelected,
    isLastMonthSelected,
    isCustomDateRangeSelected,
  };
};
